import { Component, signal } from '@angular/core';
import { NavComponent } from './nav/nav';

@Component({
  selector: 'app-root',
  imports: [NavComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  protected readonly title = signal('admin');
}
